import { combineReducers } from 'redux'

import dataReducer from './data/reducers'
import requestReducer from './requests/reducers'
import alertReducer from './alerts/reducers'
import eventsReducer from './events/reducers'

const createRootReducer = () => {
  return combineReducers({
    data: dataReducer,
    request: requestReducer,
    alert: alertReducer,
    events: eventsReducer
  })
}

export default createRootReducer
